module.exports = __webpack_public_path__ + "static/media/ic_group.700025f0.png";